<template>
  <b-field class="option">    
    <b-input type="text" class="option-text" size="64" maxlength="128" v-model="option.text" placeholder="display text" :title="keyTooltip"></b-input>
    <b-input type="text" class="machine-key" maxlength="32" pattern="[a-z0-9_-]+" v-model="option.key" placeholder="machine key" :has-counter="false"></b-input>
    <b-button v-if="mayRemove" @click="remove(index)" icon-left="minus" rounded>remove</b-button>
  </b-field>
</template>

<script>

export default {
  name: 'QuestionOption',
  props: {
     option: {
       type: Object,
       default() {
         return {
          _id: '',
          key: '',
          text: ''
        };
       }
     },
     index: {
       type: Number,
       default: -1
     },
     total: {
       type: Number,
       default: -1
     },
     other: {
       type: Boolean,
       default: false
     },
     showKey: {
       type: Boolean,
       default: false
     }
  },
  watch: {
    "option.text"(cv, pv) {
      if (!this.showKey) {
        if (this.$parent.assignOptionKey) {
          if (cv !== pv && cv.length > 1) {
            this.$parent.assignOptionKey(this.index);
          }
        }
      }
    }
  },
  computed: {
    keyTooltip() {
      return "Key: " + this.option.key;
    },
    mayRemove() {
      return this.total > 2 && this.other === false;
    }
  },
  methods: {
    remove() {
      if (this.$parent.removeOption && this.index >= 0) {
        this.$parent.removeOption(this.index);
      }
    }
  },
}
</script>